// src/utils/timezoneUtils.ts
import moment from 'moment-timezone';

export const convertToUtc = (date: Date, timezone: string): Date => {
  return moment.tz(date, timezone).utc().toDate();
};

export const convertFromUtc = (utcDate: Date, timezone: string): Date => {
  return moment.utc(utcDate).tz(timezone).toDate();
};

export const formatInTimezone = (
  utcDate: Date, 
  timezone: string, 
  format: string = "HH:mm"
): string => {
  return moment.utc(utcDate).tz(timezone).format(format);
};